'use strict';

class EventDiscountCodes {
  constructor($routeParams, $location, $filter, eventService) {
    this.$routeParams = $routeParams;
    this.$location = $location;
    this.$filter = $filter;
    this.eventService = eventService;
  }

  $onInit() {
    this.number = parseInt(this.$routeParams.number, 10);
    this.label = 'Rabattkode';
    this.codes = [];
    this.code = {
      code: null,
      amount: null,
      type: 'AMOUNT'
    };

    this.load();
  }

  load() {
    if (!isNaN(this.number)) {
      this.eventService.loadDiscountCode(this.number)
        .then((resp) => {
          this.label = resp.data.label;
          this.codes = resp.data.codes;
        });
    }
  }

  save() {
    // format amount
    this.code.amount = this.$filter('numberify')(this.code.amount);

    this.eventService.saveDiscountCode(this.number, this.code)
      .then(() => {
        this.code = {
          code: null,
          amount: null,
          type: 'AMOUNT'
        };

        this.load();
      });
  }

  delete(number) {
    swal({
      title: 'Bekreft fjerning',
      showCancelButton: true,
      confirmButtonColor: '#970b0e',
      confirmButtonText: 'Ja',
      cancelButtonText: 'Nei',
      closeOnConfirm: false,
      showLoaderOnConfirm: true
    }, (answer) => {
      if (answer) {
        this.eventService.deleteDiscountCode(this.number, number)
          .then(() => {
            this.load();
            swal.close();
          });
      }
    });
  }
}

EventDiscountCodes.$inject = ['$routeParams', '$location', '$filter', 'eventService'];

const eventDiscountCodes = {
  controller: EventDiscountCodes,
  template: `
    <h2>{{ $ctrl.label || "Rabattkode" }}</h2>

    <table ng-if="$ctrl.codes.length">
      <thead>
        <tr>
          <th>Kode</th>
          <th>Type</th>
          <th>Rabatt</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="item in $ctrl.codes track by $index">
          <td>{{ item.code }}</td>
          <td ng-show="item.type == 'AMOUNT'">Beløp</td>
          <td ng-show="item.type == 'PERCENTAGE'">%</td>
          <td ng-show="item.type == 'AMOUNT'">{{ item.amount | crowns }}</td>
          <td ng-show="item.type == 'PERCENTAGE'">{{ item.amount}}</td>
          <td width="100" class="center-align"><a href role="button" class="button secondary" ng-click="$ctrl.delete(item.number)"><i class="fa fa-trash"></i></a></td>
        </tr>
      </tbody>
    </table>

    <form name="discountCodes" novalidate ng-submit="$ctrl.save()">
      <h3 class="subheader">Legg til ny rabattkode</h3>

      <fieldset>
        <div>
          <label for="code">Kode</label>
          <input type="text" id="code" name="discountCode.code" ng-model="$ctrl.code.code">
        </div>

        <div>
          <label for="type">Type</label>
          <select class="form-control" ng-model="$ctrl.code.type" id="type">
              <option value="AMOUNT">Beløp</option>
              <option value="PERCENTAGE">%</option>
          </select>
        </div>

        <div ng-show="$ctrl.code.type == 'AMOUNT'">
          <label for="amount">Rabatt</label>
          <input type="text" id="amount" name="discountCode.amount" min="0" ng-model="$ctrl.code.amount">
        </div>

        <div ng-show="$ctrl.code.type == 'PERCENTAGE'">
          <label for="amount">%</label>
          <input type="number" name="discountCode.amount" ng-model="$ctrl.code.amount" min="0" max="100" maxlength="5">
        </div>

        <button type="submit" class="button">Lagre</button>
      </fieldset>
    </form>

    <a role="button" class="button secondary" href="#/vert/{{ $ctrl.number }}">Tilbake</a>
  `
};

angular
  .module('SendRegning')
  .component('eventDiscountCodes', eventDiscountCodes)
  .config(($routeProvider) => {
    $routeProvider
      .when('/vert/:number/rabattkode', {
        title: 'Rabattkode',
        template: '<event-discount-codes />',
        secure: true
      });
  });
